import { createClient } from "@supabase/supabase-js"

// Supabase client configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey)

const createNotConfiguredError = () =>
  new Error("Supabase is not configured for this frontend.")

const fallbackSubscription = {
  unsubscribe() {},
}

const fallbackSupabase = {
  auth: {
    signInWithPassword: async () => ({
      data: null,
      error: createNotConfiguredError(),
    }),
    signUp: async () => ({
      data: null,
      error: createNotConfiguredError(),
    }),
    signInWithOAuth: async () => ({
      data: null,
      error: createNotConfiguredError(),
    }),
    signOut: async () => ({ error: null }),
    getUser: async () => ({
      data: { user: null },
      error: null,
    }),
    updateUser: async () => ({
      data: null,
      error: createNotConfiguredError(),
    }),
    onAuthStateChange: () => ({
      data: { subscription: fallbackSubscription },
    }),
  },
}

const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : fallbackSupabase

export default supabase
